import React from 'react'
import Factory from '@leverege/factory'

const EditorFactory = new Factory( {
  strategy : Factory.reactStrategy( React )
} )

export default EditorFactory
